'use client';

import * as React from 'react';
import { Badge } from 'shared/ui/badge';
import * as SliderPrimitive from '@radix-ui/react-slider';
export default function SliderWithLabel({
  defaultValue,
  step,
  onValueChange,
  unit,
  value,
  onlyIncrease = false,
  ...props
}: React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
  value: number[];
  defaultValue: number[];
  unit?: string;
  onlyIncrease?: boolean;
}) {
  const minValue = defaultValue[0];
  const max = props.max || 100;
  return <div className="relative w-full flex flex-col items-center" data-sentry-component="SliderWithLabel" data-sentry-source-file="slider-with-label.tsx">
      <SliderPrimitive.Root value={value} step={step} onValueChange={onValueChange} className="relative flex w-full touch-none select-none items-center data-[disabled]:opacity-50" {...props} data-sentry-element="unknown" data-sentry-source-file="slider-with-label.tsx">
        <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-primary/20" data-sentry-element="unknown" data-sentry-source-file="slider-with-label.tsx">
          {onlyIncrease && <div className="absolute h-full bg-primary rounded-full" style={{
          left: `${minValue / max * 100}%`,
          width: `${(value[0] - minValue) / max * 100}%`
        }} />}
          <SliderPrimitive.Range className={`absolute h-full ${onlyIncrease ? ' bg-primary/40' : 'bg-primary'}`} data-sentry-element="unknown" data-sentry-source-file="slider-with-label.tsx" />
        </SliderPrimitive.Track>

        <SliderPrimitive.Thumb className="group block size-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" data-sentry-element="unknown" data-sentry-source-file="slider-with-label.tsx">
          {/* Sticky label */}
          <Badge className="scale-0 group-hover:scale-100 transition-transform absolute left-1/2 -translate-x-1/2 -translate-y-1/2 -top-4" data-sentry-element="Badge" data-sentry-source-file="slider-with-label.tsx">
            {value} <span>{unit}</span>
          </Badge>
        </SliderPrimitive.Thumb>
      </SliderPrimitive.Root>
    </div>;
}